module.exports = __webpack_public_path__ + "img/header-by.30342de3.jpg";